// extracted by mini-css-extract-plugin
export default {"body":"Body-module__body___CM0nf"};